import Navbar from "../../component/Navbar";
import DropdownMenu from "../../component/DropdownMenu";
import Footer from "../../component/Footer";
import { useState } from "react";
import PageTransition from "../../component/PageTransition";

export default function Page() {
  const [showContent, setShowContent] = useState(false);

  return (
    <>
      <PageTransition showContent={showContent} setShowContent={setShowContent}>
          พันธกิจและวิสัยทัศน์
      </PageTransition>
      {showContent && (
        <div className="relative">
          <Navbar />
          <div className="flex flex-col gap-y-5">
            <DropdownMenu />

            <div className="container mx-auto w-full px-5 py-5 md:px-0 md:py-0">
              <div className=" grid gid-cols-1 md:grid-cols-3 gap-5 mt-0 md:mt-10 mb-20">
                <div className="w-full flex justify-center order-2 md:order-1">
                  <div className="flex flex-col items-start gap-4 p-4 bg-[#9e76b43d] rounded-lg shadow-md">
                    <div className="flex items-center gap-x-3">
                      <div className="border-2 border-[#5eafd2] bg-white px-[12px] py-2 rounded-xl">
                        <span className="text-5xl text-[#5eafd2] font-bold">
                          V
                        </span>
                      </div>
                      <div>
                        <span className="text-xl font-bold text-cyan-600">
                          Versatility
                        </span>
                        <p className="text-sm text-gray-500">
                          ความสามารถในการปรับตัว มีความยืดหยุ่นในการทำงาน
                          และหน้าที่ต่างๆ ได้อย่างหลากหลาย และมีประสิทธิ์ภาพ
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-x-3">
                      <div className="border-2 border-[#5eafd2] bg-white px-[10px] py-2 rounded-xl">
                        <span className="text-5xl text-[#5eafd2] font-bold">
                          M
                        </span>
                      </div>
                      <div>
                        <span className="text-xl font-bold text-cyan-600">
                          Motivation{" "}
                        </span>
                        <p className="text-sm text-gray-500">
                          ส่งเสริมและผลักดัน
                          ให้กำลังใจในการทำงานระหว่างกัรและกันในผู้ร่วมงาน
                          เพื่อให้มีความสัมพันธ์และประสิทธิภาพที่ดียิ่งขึ้น
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-x-3">
                      <div className="border-2 border-[#5eafd2] bg-white px-[13px] py-2 rounded-xl">
                        <span className="text-5xl text-[#5eafd2] font-bold">
                          C
                        </span>
                      </div>
                      <div>
                        <span className="text-xl font-bold text-cyan-600">
                          Community Engagemment{" "}
                        </span>
                        <p className="text-sm text-gray-500">
                          มุ่งเน้นท้องถิ่น และมีความรับผิดชอบต่อสังคม
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-x-3">
                      <div className="border-2 border-[#5eafd2] bg-white px-[10px] py-2 rounded-xl">
                        <span className="text-5xl text-[#5eafd2] font-bold">
                          M
                        </span>
                      </div>
                      <div>
                        <span className="text-xl font-bold text-cyan-600">
                          Morality{" "}
                        </span>
                        <p className="text-sm text-gray-500">
                          ยึดหลักธรรมมาภิบาล เชิดชูคุณธรรม
                          พัฒนาจิตอาสา/จิตสาธารณะ/จิตบริการ
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-x-3">
                      <div className="border-2 border-[#5eafd2] bg-white px-[10px] py-2 rounded-xl">
                        <span className="text-5xl text-[#5eafd2] font-bold">
                          U
                        </span>
                      </div>
                      <div>
                        <span className="text-xl font-bold text-cyan-600">
                          Unity{" "}
                        </span>
                        <p className="text-sm text-gray-500">
                          ทำงานเป็นทีม บุคลากรสามัคคี และเป็นองค์กรแห่งความสุข
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full flex justify-center order-1 md:order-2">
                  <div className="flex flex-col  items-center gap-3">
                    <div className="">
                      <img
                        src="https://general.vet.cmu.ac.th/VMCMU.png"
                        alt=""
                      />
                    </div>
                    <h1 className="text-[#5eafd2] text-3xl font-bold">
                      VM<span className="text-[#9e76b4]">CMU</span>
                    </h1>
                    <p className="text-gray-600 text-sm">
                      Versatility Motivation Community Engagemment Morality
                      Unity
                    </p>
                    <h5 className="text-center text-gray-600">
                      Faculty of Veterinary Medicine
                    </h5>
                    <div className="flex flex-col text-center">
                      <h1 className="text-2xl text-gray-600">วิสัยทัศน์</h1>
                      <p className="text-sm text-gray-600">
                        คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่
                        เป็นสถานศึกษาชั้นนำในเอเชีย และรับใช้สังคม
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full flex justify-center order-3 md:order-3">
                  <div className="flex flex-col items-start gap-4 p-4 bg-[#5eafd260] rounded-lg shadow-md">
                    <h1 className="text-3xl text-[#9e76b4]">
                      พันธกิจ และเป้าหมาย
                    </h1>
                    <div className="flex items-center gap-x-3">
                      <i className="fa-solid fa-arrows-to-dot text-[#9e76b4]"></i>
                      <p className="text-gray-500">
                        จัดการศึกษาระดับอุดมศึกษาและวิชาชีพชั้นสูงโดยมุ่งเน้นความเป็นเลิศทางวิชาการ
                        บัณฑิตมีคุณภาพตามมาตรฐานสากล และรอบรู้คู่คุณธรรม
                        ตามหลักปรัชญาเศรษฐกิจพอเพียง
                      </p>
                    </div>
                    <div className="flex items-center gap-x-3">
                      <i className="fa-solid fa-arrows-to-dot text-[#9e76b4]"></i>
                      <p className="text-gray-500">
                        ผลิตผลงานวิจัยทางสัตวแพทย์
                        เพื่อสามารถสนับสนุนการเรียนการสอนและการถ่ายทอดเทคโนโลยี
                        เพื่อพัฒนาเศรษฐกิจสังคมของประเทศ
                      </p>
                    </div>
                    <div className="flex items-center gap-x-3">
                      <i className="fa-solid fa-arrows-to-dot text-[#9e76b4]"></i>
                      <p className="text-gray-500">
                        ให้บริการวิชาการแก่สังคม
                        มีส่วนร่วมพัฒนาชุมชนให้เข้มแข็งด้วยหลักปรัชญาเศรษฐกิจพอเพียง
                      </p>
                    </div>
                    <div className="flex items-center gap-x-3">
                      <i className="fa-solid fa-arrows-to-dot text-[#9e76b4]"></i>
                      <p className="text-gray-500">
                        ทำนุบำรุงศาสนา ศิลปวัฒนธรรม
                        อนุรักษ์และพัฒนาทรัพยากรธรรมชาติและสิ่งแวดล้อมอย่างยั่งยืน
                        เพื่อความเป็นเอกลักษณ์ของท้องถิ่นภาคเหนือ
                      </p>
                    </div>
                    <div className="flex items-center gap-x-3">
                      <i className="fa-solid fa-arrows-to-dot text-[#9e76b4]"></i>
                      <p className="text-gray-500">
                        พัฒนาระบบบริหารจัดการ ด้วยหลักธรรมมาภิบาล
                        พึ่งตนเองโดยใช้หลักปรัชญาเศรษฐกิจพอเพียง
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
}
